import { ReaderNavigationContext } from "../screens/reader/types";

export function buildContextQueryParams(
  context?: ReaderNavigationContext,
): URLSearchParams {
  const params = new URLSearchParams();
  if (context) {
    Object.entries(context).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        params.append(
          `context_${key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)}`,
          value.toString(),
        );
      }
    });
  }
  return params;
}
